// Gates the PA interstitials (onboarding, daily briefing) until the app shell with its sidebar is on
// screen. Their data signals can resolve during the initial `/` load, before app.component mounts the
// nz-sider, so an overlay would float over the bare loader. This mirrors app.component's own sidebar
// condition, reading only the router and auth streams.
import { inject, Injectable } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { NavigationEnd, NavigationSkipped, Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { combineLatest, filter, map, startWith } from 'rxjs'
import { RouteName } from '../../../core/enums/route-name.enum'
import { AuthState } from '../../../store/auth/auth.state'

@Injectable({ providedIn: 'root' })
export class PaShellReadyService {
  private readonly router = inject(Router)
  private readonly store = inject(Store)

  // True once the router lands on a sidebar-bearing route: the predicate app.component uses for nz-sider.
  private readonly onShellRoute$ = this.router.events.pipe(
    filter(
      (e): e is NavigationEnd | NavigationSkipped =>
        e instanceof NavigationEnd || e instanceof NavigationSkipped
    ),
    map(
      e =>
        e.url !== '/' + RouteName.Login &&
        !e.url.includes(RouteName.Resident) &&
        !e.url.includes('/' + RouteName.Insight + '/')
    ),
    startWith(false)
  )

  /** True when authenticated and on a sidebar-bearing route. */
  readonly ready = toSignal(
    combineLatest([
      this.store.select(AuthState.isAuthenticated).pipe(startWith(false)),
      this.onShellRoute$
    ]).pipe(map(([authed, onShellRoute]) => authed && onShellRoute)),
    { initialValue: false }
  )
}
